// extracted by mini-css-extract-plugin
export default {"cityButton":"CustomAccordions_cityButton__Tgdfk","buttonText":"CustomAccordions_buttonText__n2xyM"};